// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"555":"8db1bd27","787":"b49fcdc9"}[chunkId] + ".chunk.js";
};